import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message'
import utils from '../../utils/index'
import { labelConsultaRemessa, mensagemResultadoCancelamento, mensagensResultadoReprocesso } from './consultaRemessa.utils'

const BASE_PATH = '/lottustech/remessasfinanceiras'
const crud = build(validate, BASE_PATH)
const prefix = 'crudConsultaRemessa'

const actions = new Action(prefix, crud)
const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  UNMOUNT: `${prefix}unmount`,
  RESET: `${prefix}reset`,
}

const types = Object.assign({}, actions.types, newTypes)

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.unmount = () => {
  return {
    type: types.UNMOUNT,
  }
}

actions.imprimirBoletos = (itens) => {
  return (dispatch, getState) => {
    apiService
      .post(`/lottustech/ailos/gerar/remessaBoletos/`, itens)
      .then((response) => {
        const win = window.open(response.data)
        win.focus()
      })
      .catch((err) => {
        const messages = err.response.data
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })
  }
}

actions.sincronizarRemessa = (oidRemessa) => {
  return (dispatch, getState) => {
    apiService
      .post(`/lottustech/ailos/sincronizarRemessa`, oidRemessa)
      .then((response) => {
        dispatch(messageActions.messageShowMessages(makeMessages(['Remessa sincronizada'], 'success')))
      })
      .catch((err) => {
        const messages = err.response.data
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })
  }
}

actions.downloadArquivo = (oidRemessa) => {
  return (dispatch, getState) => {
    return apiService
      .get(`${BASE_PATH}/download/${oidRemessa}`)
      .then((response) => {
        let data = response.data
        utils.createAndDownloadBlobFile(data.conteudo, data.nome)
      })
      .catch((err) => {
        const messages = err.response.data
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })
  }
}

actions.downloadArquivos = (oidsRemessa) => {
  return (dispatch, getState) => {
    return apiService
      .post(`${BASE_PATH}/download`, oidsRemessa)
      .then((response) => {
        let data = response.data
        utils.createAndDownloadBlobFile(data.conteudo, data.nome)
      })
      .catch((err) => {
        const messages = err.response.data
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })
  }
}

const mensagensDaTela = (getState) => getState().crudConsultaRemessaState.messages

/** Texto de erro da resposta: 400 traz a mensagem do back; 404/500 sem corpo caem no label generico. */
const textoDoErro = (err, getState, chavePadrao) => {
  const corpo = err && err.response ? err.response.data : null
  if (typeof corpo === 'string' && corpo.trim() !== '') {
    return corpo
  }
  return labelConsultaRemessa(mensagensDaTela(getState), chavePadrao)
}

/**
 * PHOENIX-977: uma pagina de itens da remessa (a grade pagina no servidor). Devolve a promise com
 * { itens, total } ou, na falha, { itens: [], total: 0, erro }. O toast e do container: so ele sabe se
 * esta resposta ainda e a da grade (uma mais nova pode ter chegado antes).
 */
actions.loadItens = (oidRemessa, params) => {
  return (dispatch, getState) => {
    return apiService
      .post(`${BASE_PATH}/${oidRemessa}/itens`, params)
      .then((response) => response.data || { itens: [], total: 0 })
      .catch((err) => ({ itens: [], total: 0, erro: textoDoErro(err, getState, 'erroCarregarItens') }))
  }
}

actions.mostrarErro = (texto) => {
  return (dispatch) => {
    dispatch(messageActions.messageShowMessages(makeMessages([texto], 'error')))
  }
}

/**
 * Lista vazia = todos os itens em ERRO (o back resolve). PHOENIX-977: a remessa assincrona devolve o
 * resumo, que vira a mensagem; a sincrona continua sem corpo. Devolve a promise (true = deu certo).
 */
actions.reprocessar = (itens, oidRemessa) => {
  return (dispatch, getState) => {
    const oidsLancamentos = (itens || []).map((item) => item.oidLancamentoFinanceiro)
    const params = {
      oidRemessa,
      oidsLancamentos,
    }
    return apiService
      .post(`${BASE_PATH}/reprocessar`, params)
      .then((response) => {
        mensagensResultadoReprocesso(mensagensDaTela(getState), response.data).forEach((m) =>
          dispatch(messageActions.messageShowMessages(makeMessages([m.texto], m.tipo)))
        )
        return true
      })
      .catch((err) => {
        dispatch(messageActions.messageShowMessages(makeMessages([textoDoErro(err, getState, 'erroOperacao')], 'error')))
        return false
      })
  }
}

/** PHOENIX-977: "Cancelar pendentes" da remessa assincrona em andamento. Devolve a promise (true = deu certo). */
actions.cancelarPendentes = (oidRemessa) => {
  return (dispatch, getState) => {
    return apiService
      .post(`${BASE_PATH}/${oidRemessa}/cancelarPendentes`, {})
      .then((response) => {
        const texto = mensagemResultadoCancelamento(mensagensDaTela(getState), response.data)
        dispatch(messageActions.messageShowMessages(makeMessages([texto], 'success')))
        return true
      })
      .catch((err) => {
        dispatch(messageActions.messageShowMessages(makeMessages([textoDoErro(err, getState, 'erroOperacao')], 'error')))
        return false
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = 'Sucesso!'
  if (type === 'error') {
    summary = 'Erro!'
    sticky = true
  } else if (type === 'warn') {
    summary = 'Aviso!'
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
